export default class ImageLoader {
  private handleLoad: () => void;
  private handleError: () => void;
  private img: HTMLImageElement;
  private loading: boolean;

  public get isLoading() {
    return this.loading;
  }

  public get imageElement() {
    return this.img;
  }

  public disconnect() {
    const { img } = this;
    img.removeEventListener('load', this.handleLoad);
    img.removeEventListener('error', this.handleError);
    this.loading = false;
  }

  public constructor(src: string, onLoad: (img: HTMLImageElement) => void, onError: () => void) {
    this.handleLoad = () => {
      this.disconnect();
      onLoad(this.img);
    };

    this.handleError = () => {
      this.disconnect();
      onError();
    };

    this.img = new Image();
    const { img } = this;
    img.addEventListener('load', this.handleLoad);
    img.addEventListener('error', this.handleError);
    img.src = src;

    this.loading = true;
  }
}
